import React from 'react';
import useGoTo from '@src/features/drone/hooks/useGoTo';

export type GoHereContextValue = ReturnType<typeof useGoTo>;

const GoHereContext = React.createContext<GoHereContextValue | null>(null);

export const GoHereProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useGoTo();
  return <GoHereContext.Provider value={value}>{children}</GoHereContext.Provider>;
};

export function useGoHere(): GoHereContextValue {
  const ctx = React.useContext(GoHereContext);
  if (!ctx) {
    throw new Error('useGoHere must be used within GoHereProvider');
  }
  return ctx;
}

export function useGoHereOptional(): GoHereContextValue | null {
  return React.useContext(GoHereContext);
}
